import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import getClasses from "utils/getClasses";

type Props = {
  show: boolean;
  onHide?: () => void;
  /**
   * duration for the saved tag to show
   * @default 2000
   */
  duration?: number;
  errorMsg?: string;
  className?: string;
};
const ErrorTag = ({ show, onHide, duration, errorMsg, className }: Props) => {
  const [localShow, setLocalShow] = useState(show);

  useEffect(() => setLocalShow(show), [show]);

  useEffect(() => {
    if (!localShow) {
      return;
    }
    const timer = setTimeout(() => {
      setLocalShow(false);
      onHide && onHide();
    }, duration ?? 2000);

    return () => timer && clearTimeout(timer);
  }, [localShow, onHide, duration]);

  return localShow ? (
    <div className={getClasses(styles["error-tag"], className)}>
      <div className={styles["error-tag__content"]}>
        <div>{errorMsg || "Oops...something went wrong."}</div>
      </div>
    </div>
  ) : null;
};

export default ErrorTag;
